import { Avatar, Popover } from 'antd'
import { observer } from 'mobx-react-lite'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useStore } from '../../../hooks'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CONFIG_URL } from '../../../helpers/constants'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import Images from 'src/common/Images'
import { get, isEmpty } from 'lodash'
import useModal from 'src/helpers/modal/useModal'

const UserMenuWrapper = styled.ul`
   p {
      margin-top: auto;
      margin-bottom: auto;
      margin-left: 8px;
   }
   li {
      img {
         width: 20px;
         height: 20px;
      }
      display: flex;
      width: 100%;
   }
`
const UserInfoWrapper = styled.span`
   color: white;
   cursor: pointer;
   margin-top: auto;
   margin-bottom: auto;
   margin-right: 10px;
   p {
      margin: unset;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-break: anywhere;
      max-width: 130px;
      @media (min-width: 1100px) {
         max-width: 200px;
      }
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      /* identical to box height, or 157% */
      color: #333333;
   }
   .user-info__name {
      display: flex;
   }
   .user-info__role-tag {
      margin-left: 4px;
      height: 18px;
      padding: 0 6px;
      background: ${(props) => props.theme.color.dark_2};
      border-radius: 200px;
      color: ${(props) => props.theme.color.white};
      p {
         font-size: 10px;
         line-height: 18px;
         margin: unset;
      }
   }
   div.user-info__price {
      margin: unset;
      font-weight: 400;
      font-size: 10px;
      line-height: 22px;
      & > p {
         color: ${(props) => props.theme.color.dark_1};
      }
      color: ${(props) => props.theme.color.dark_1};
      display: flex;
      justify-content: start;
   }
`

const UserProfile = observer((props: any) => {
   const AuthStore = useStore('AuthStore')
   // const JobsStore = useStore('JobsStore')
   // const CommonConfigStore = useStore('CommonConfigStore')
   const [visiblePopover, setVisiblePopover] = useState(false)
   const { confirm } = useModal()
   const { t } = useTranslation()
   const { hiddenInfo } = props
   const { data_getUserInfo, data_role } = AuthStore

   const history = useHistory()
   const handleAdminLogoutClick = () => {
      setVisiblePopover(false)
      setTimeout(() => {
         confirm({
            title: t('confirm_logout_message'),
            icon: <ExclamationCircleOutlined />,
            content: t('logout_description'),
            okText: t('yes'),
            cancelText: t('cancel'),
            async onOk() {
               AuthStore.action_logout(history)
               // JobsStore.resetJobs()
            },
            onCancel() {}
         })
      }, 100)
   }

   const handleVisibleChange = (visible: any) => {
      setVisiblePopover(visible)
   }

   const handleNavigateProfiles = () => {
      setVisiblePopover(false)
      history.push('/profiles')
   }
   const userMenuOptions = (
      <UserMenuWrapper
         className="gx-user-popover"
         style={{ minWidth: 194, paddingLeft: 8, paddingRight: 8, paddingTop: 12, paddingBottom: 12 }}
      >
         <li onClick={handleNavigateProfiles}>
            <img src={Images.ic_user} alt="" />
            <p>{t('profile')}</p>
         </li>

         <li onClick={handleAdminLogoutClick}>
            <img src={Images.logout} style={{ height: 16, width: 16, marginLeft: 4 }} alt="" />
            <p>{t('logout')}</p>
         </li>
      </UserMenuWrapper>
   )

   return (
      <div className="gx-flex-row gx-align-items-center">
         <Popover
            placement="bottomRight"
            content={userMenuOptions}
            trigger="click"
            visible={visiblePopover}
            onVisibleChange={handleVisibleChange}
            overlayStyle={{ zIndex: '1032' }}
         >
            <div style={{ display: 'flex' }}>
               <Avatar
                  src={
                     !isEmpty(data_getUserInfo?.avatar)
                        ? CONFIG_URL.IMAGE_URL + '/' + data_getUserInfo?.avatar
                        : Images.ic_user_default
                  }
                  className="gx-pointer image-avatar"
                  alt="avatar"
                  style={{ marginRight: 12, width: 40, height: 40 }}
               />
               {/* TODO */}
               {!hiddenInfo && (
                  <UserInfoWrapper>
                     <div className="user-info__name text-oneline gx-mt-auto gx-mb-auto">
                        <p>{data_getUserInfo?.name || ''}</p>
                     </div>
                     <div className="user-info__price">
                        <p>{data_getUserInfo?.role || ''}</p>
                     </div>
                  </UserInfoWrapper>
               )}
            </div>
         </Popover>
      </div>
   )
})

export default UserProfile
